export function getToasts(state) {
  return state.toast.toasts;
}
